<template>
  <div class="programare-mobile-content">
    <header class="pnm-nav-bar">
      <button class="pnm-back-btn"
              type="button"
              cy="mobile-back-btn"
              @click="anuleaza">
        <img src="../assets/back.svg" alt="back icon">
        <span>Înapoi</span>
      </button>
      <h3 class="pnm-nav-title">{{ lang.programareNouaStepTitle }}</h3>
      <div class="pnm-nav-actions">
        <template v-if="$router.currentRoute.params.id">
          <router-link cy="comanda-btn"
                       :to="'/comanda/' + $router.currentRoute.params.id">Comandă</router-link>
          <router-link cy="deviz-btn"
                       :to="'/deviz/' + $router.currentRoute.params.id">Deviz</router-link>
        </template>
      </div>
    </header>

    <ValidationObserver ref="observer">
      <div class="pnm-content relative">
        <div v-if="isAutocomplete && $store.getters[activeFieldModel] && $store.getters[activeFieldModel].length">
          <Autocomplete ref="autocomplete"
                        :name="activeFieldModel"
                        :positionY="autocompletePositionY"
                        :positionX="autocompletePositionX"
                        :list="$store.getters[activeFieldModel]"
                        @select-item="handleAutocompleteItem"
                        @hide="hideAutocomplete" />
        </div>

        <!-- DETALII AUTO -->
        <p class="pnm-section-title">{{ lang.autoDetails }}</p>
        <div class="pnm-card">
          <ul>
            <li v-for="item in auto"
                :key="item.model"
                class="pnm-row"
                :class="{ 'pnm-row--focus': activeFieldModel === item.model }"
                :cy="`input-group-${item.model}`">
              <validation-provider :rules="item.rules" v-slot="{ errors }">
                <div class="pnm-row-inner" :class="{ 'pnm-row--invalid': errors[0] }">
                  <label :for="item.model">{{ item.label }}</label>
                  <input :id="item.model"
                         :cy="item.model"
                         :ref="item.model"
                         v-model="data.car[item.model]"
                         class="pnm-row-input uppercase"
                         :class="{ 'pnm-row-input--error': errors[0] }"
                         type="text"
                         :placeholder="errors[0] ? fieldErrorText(item) : item.placeholder"
                         @focus="handleCarFieldFocus($event, item.model)"
                         @blur="activeFieldModel = undefined"
                         @keyup="handleCarFieldInput($event, item.model)">
                </div>
              </validation-provider>
            </li>
          </ul>
        </div>
        <textarea class="pnm-textarea"
                  v-model="data.car.observatii"
                  placeholder="observații"></textarea>

        <!-- DETALII CLIENT -->
        <p class="pnm-section-title">{{ lang.clientDetails }}</p>
        <div class="pnm-card">
          <ul>
            <li v-for="item in client"
                :key="item.model"
                class="pnm-row"
                :class="{ 'pnm-row--focus': activeFieldModel === item.model }"
                :cy="`input-group-${item.model}`">
              <validation-provider :rules="item.rules" v-slot="{ errors }">
                <div class="pnm-row-inner" :class="{ 'pnm-row--invalid': errors[0] }">
                  <label :for="item.model">{{ item.label }}</label>
                  <input :id="item.model"
                         :cy="item.model"
                         v-model="data.client[item.model]"
                         class="pnm-row-input uppercase"
                         :class="{ 'pnm-row-input--error': errors[0] }"
                         :type="item.type || 'text'"
                         :placeholder="errors[0] ? fieldErrorText(item) : item.placeholder"
                         :autocomplete="'as9dasd11' + item.model"
                         @focus="activeFieldModel = item.model"
                         @blur="activeFieldModel = undefined">
                </div>
              </validation-provider>
            </li>
          </ul>
        </div>

        <!-- DETALII REPARATII -->
        <p class="pnm-section-title">{{ lang.repairsDetails }}</p>
        <div class="pnm-card pnm-editable-card">
          <p class="pnm-editable-label">Defecțiuni</p>
          <div class="pnm-editable"
               cy="defectiuni"
               ref="defectiuni"
               contenteditable="true"
               data-placeholder="Descrieți defectele constatate..."
               v-html="data.comanda.defectiuni"></div>
          <p class="pnm-editable-label">Piese client</p>
          <div class="pnm-editable"
               cy="piese-client"
               ref="piese_client"
               contenteditable="true"
               data-placeholder="Enumerați piesele furnizate..."
               v-html="data.comanda.piese_client"></div>
        </div>

        <!-- PROGRAMARE -->
        <p class="pnm-section-title">{{ lang.programareNouaStepTitle }}</p>
        <div class="pnm-booking">
          <IOSCalendar cy="booking-date"
                       :value="bookingDate"
                       disable-past
                       @input="bookingDate = $event" />
          <IOSTimeGrid cy="booking-time"
                       :value="bookingTime"
                       :hours-label="lang.bookingHourLabel"
                       :minutes-label="lang.bookingMinuteLabel"
                       @input="bookingTime = $event" />
          <p class="pnm-summary"
             cy="booking-summary"
             :class="{ 'pnm-summary--empty': !bookingSummary }">
            {{ bookingSummary || lang.bookingSummaryEmpty }}
          </p>
        </div>
      </div>

      <p v-if="saveError"
         cy="save-error"
         class="pnm-save-error">{{ saveError }}</p>

      <div class="pnm-actions">
        <button class="pnm-cancel-btn"
                type="button"
                cy="cancel"
                :disabled="isSaving"
                @click="anuleaza">
          {{ lang.quitBtn }}
        </button>
        <button class="pnm-save-btn"
                type="button"
                cy="submit"
                :disabled="isSaving"
                @click="onSubmit">
          {{ isSaving ? lang.saving : lang.saveBtn }}
        </button>
      </div>
    </ValidationObserver>
  </div>
</template>

<script>
  import { mapState, mapGetters } from 'vuex'
  import IOSCalendar from './ios-picker/IOSCalendar.vue'
  import IOSTimeGrid from './ios-picker/IOSTimeGrid.vue'

  export default {
    name: 'ProgramareNouaMobile',
    components: { IOSCalendar, IOSTimeGrid },
    data () {
      return {
        auto: [
          { label: 'Număr auto', model: 'numar', rules: 'required', placeholder: 'Ex: B 123 ABC' },
          { label: 'Marcă', model: 'marca', rules: 'required', placeholder: 'Ex: Dacia' },
          { label: 'Model', model: 'model', rules: 'required', placeholder: 'Ex: Logan' }
        ],
        client: [
          { label: 'Nume', model: 'nume', rules: 'required', placeholder: 'Ex: Popescu Ion' },
          { label: 'Telefon', model: 'telefon', type: 'tel', rules: 'required', placeholder: 'Ex: 0712 345 678' }
        ],
        activeFieldModel: undefined,
        autocompleteFields: [
          { field: 'numar', commit: 'FILTER_CAR_NUMBER' },
          { field: 'marca', commit: 'FILTER_CAR_BRAND' },
          { field: 'model', commit: 'FILTER_CAR_MODEL' }
        ],
        isAutocomplete: false,
        autocompletePositionY: 0,
        autocompletePositionX: 0,
        isSaving: false,
        saveError: ''
      }
    },
    created () {
      this.$store.dispatch('get_clienti')
    },
    computed: {
      ...mapState({
        data: state => state.comenzi.comanda,
        clients_list: state => state.clienti.clienti
      }),
      ...mapGetters(['numar', 'marca', 'model', 'lang']),
      bookingDate: {
        get () {
          return this.data.booking_date || ''
        },
        set (value) {
          this.$store.commit('UPDATE_COMANDA_NOUA_FIELD', { key: 'booking_date', value })
        }
      },
      bookingTime: {
        get () {
          return this.data.booking_time || ''
        },
        set (value) {
          this.$store.commit('UPDATE_COMANDA_NOUA_FIELD', { key: 'booking_time', value })
        }
      },
      bookingSummary () {
        const date = this.bookingDate
        const time = this.bookingTime
        if (!date || !time) return ''
        const m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(date)
        if (!m) return ''
        const y = +m[1]
        const mo = +m[2]
        const d = +m[3]
        const dt = new Date(y, mo - 1, d)
        if (isNaN(dt.getTime())) return ''
        const weekIdx = (dt.getDay() + 6) % 7
        const weekday = (this.lang.days?.[weekIdx] || '').toLowerCase()
        const monthShort = (this.lang.months?.[mo - 1] || '').slice(0, 3)
        return (this.lang.bookingSummary || '')
          .replace('{weekday}', weekday)
          .replace('{day}', d)
          .replace('{month}', monthShort)
          .replace('{time}', time)
      }
    },
    methods: {
      async onSubmit () {
        const observer = this.$refs.observer
        const valid = observer ? await observer.validate() : true
        if (!valid) {
          this.$nextTick(() => this._scrollToFirstInvalid())
          return
        }
        await this.submit()
      },
      _scrollToFirstInvalid () {
        const root = this.$el
        if (!root) return
        const first = root.querySelector('.pnm-row--invalid')
        if (!first) return
        if (typeof first.scrollIntoView === 'function') {
          first.scrollIntoView({ behavior: 'smooth', block: 'center' })
        }
        const input = first.querySelector('input, textarea')
        if (input && typeof input.focus === 'function') {
          setTimeout(() => input.focus({ preventScroll: true }), 300)
        }
      },
      async submit () {
        const fields = ['defectiuni', 'piese_client']
        fields.forEach((key) => {
          const htmlVal = this.$refs[key]?.innerHTML
          this.$store.commit('UPDATE_COMANDA_HTML_FIELD', { key, htmlVal })
        })
        this.isSaving = true
        this.saveError = ''
        try {
          if (this.data._id) {
            await this.$store.dispatch('update_comanda', this.data._id)
          } else {
            this.data.status = 0
            await this.$store.dispatch('create_programare', this.data)
            this.$toast.success(this.lang.programariSchedule.createSuccessToast)
          }
        } catch (e) {
          this.saveError = this.lang.programariSchedule.saveError
          this.$toast.error(this.saveError)
        } finally {
          this.isSaving = false
        }
      },
      anuleaza () {
        this.$store.commit('SET_KEY_VALUE', { key: 'comanda', value: {} })
        this.$router.push('/programari')
      },
      handleAutocompleteItem ({ name, value }) {
        if (name === 'numar') {
          const details = this.$store.state.templates.carsNumbers
            .filter(o => o.numar === value)[0]
          this.$store.commit('SET_CAR_DETAILS', details)
          const clientDetails = details && details.client_id &&
            this.clients_list.find(c => c._id === details.client_id)
          if (clientDetails) {
            this.$store.commit('SET_CLIENT_FIELD_VALUE', { name: 'nume', value: clientDetails.nume || '' })
            this.$store.commit('SET_CLIENT_FIELD_VALUE', { name: 'telefon', value: clientDetails.telefon || '' })
          }
        } else {
          this.$store.commit('SET_CAR_FIELD_VALUE', { name, value })
        }
        this.isAutocomplete = false
        const elmIndex = this.auto.findIndex(o => o.model === name)
        setTimeout(() => {
          const index = name === 'numar' ? elmIndex + 4 : elmIndex + 1
          this.$refs[this.auto[index]?.model]?.[0]?.focus()
        }, 0)
        name === 'marca' && this.$store.commit('SET_CARS_MODELS', value)
      },
      handleCarFieldFocus ({ target }, fieldName) {
        this.activeFieldModel = fieldName
        const section = this.autocompleteFields.filter(o => o.field === fieldName)
        this.isAutocomplete = !!section.length
        this.autocompletePositionY = target.offsetTop + target.offsetHeight + 4
        this.autocompletePositionX = target.offsetLeft
      },
      handleCarFieldInput ({ key }, fieldName) {
        if (this.isAutocomplete) {
          const section = this.autocompleteFields.filter(o => o.field === fieldName)[0]
          const value = this.data.car[fieldName] || ''
          const a_z = !!key && /[0-9a-zA-Z]/.test(key) && key.length === 1
          switch (key) {
            case 'Backspace':
              this.$store.commit(section.commit, value.toLowerCase())
              break
            default:
              !!value && a_z && this.$store.commit(section.commit, value.toLowerCase())
          }
        }
      },
      hideAutocomplete () {
        this.isAutocomplete = false
      },
      fieldErrorText (item) {
        return (this.lang.fieldRequired || '').replace('{field}', item.label.toLowerCase())
      }
    }
  }
</script>

<style lang="less">
  @import "../styles/var";

  .programare-mobile-content {
    @media only screen and (min-width: 0) {
      // @danger (#f3685f) is ~3:1 on white — fine for borders/underlines but
      // fails WCAG AA (4.5:1) for text, so error copy uses this darker shade.
      @pnm-error-text: #c0392b;

      margin-top: 60px;
      background-color: #f2f2f7;
      font-family: -apple-system, BlinkMacSystemFont, "SF Pro Text", "Helvetica Neue", Helvetica, Arial, sans-serif;
      -webkit-font-smoothing: antialiased;

      .pnm-nav-bar {
        position: sticky;
        top: 0;
        z-index: 10;
        display: grid;
        grid-template-columns: 1fr auto 1fr;
        align-items: center;
        background-color: #f9f9f9f0;
        backdrop-filter: saturate(180%) blur(20px);
        border-bottom: 0.5px solid rgba(60, 60, 67, 0.18);
        padding: 0 16px;

        .pnm-back-btn {
          display: flex;
          align-items: center;
          gap: 4px;
          background-color: transparent;
          -webkit-tap-highlight-color: transparent;
          > span {
            font-size: 1.7rem;
            color: #007aff;
          }
        }

        .pnm-nav-title {
          font-size: 1.7rem;
          font-weight: 600;
          color: #1c1c1e;
          letter-spacing: -0.02em;
          margin: 11px;
          text-align: center;
        }

        .pnm-nav-actions {
          display: flex;
          justify-content: flex-end;
          align-items: center;
          gap: 12px;
          a {
            font-size: 1.5rem;
            font-weight: 500;
            color: #007aff;
          }
        }
      }

      .pnm-content {
        padding: 20px 20px 20px;
      }

      .pnm-section-title {
        margin: 5px;
        font-size: 1.3rem;
        font-weight: 400;
        color: #6b6b70;
        text-transform: uppercase;
      }

      .pnm-card {
        padding: 0 16px;
        margin-bottom: 20px;
        border-radius: 12px;
        background-color: white;
        box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);

        ul {
          list-style: none;
        }
      }

      .pnm-row {
        border-bottom: 0.5px solid rgba(60, 60, 67, 0.18);

        &:last-child {
          border-bottom: none;
        }

        &:has(.pnm-row--invalid) {
          border-bottom-color: @danger;
          border-bottom-width: 1px;
        }

        .pnm-row-inner {
          display: flex;
          align-items: center;
          justify-content: space-between;
          gap: 12px;
          padding: 10px 0;

          label {
            font-size: 1.6rem;
            color: #1c1c1e;
            white-space: nowrap;
          }
        }

        .pnm-row-input {
          flex: 1;
          border: none;
          background: transparent;
          text-align: right;
          font-size: 1.6rem;
          font-weight: 500;
          color: #6b6b70;

          &::placeholder {
            font-weight: 400;
            text-transform: none;
          }

          &:focus {
            outline: none;
            color: #007aff;
          }

          &--error::placeholder {
            color: @pnm-error-text;
          }

          &[type="number"] {
            -moz-appearance: textfield;

            &::-webkit-inner-spin-button,
            &::-webkit-outer-spin-button {
              -webkit-appearance: none;
              margin: 0;
            }
          }
        }

        .pnm-row-inner.pnm-row--invalid label {
          color: @pnm-error-text;
        }
      }

      input::placeholder,
      .pnm-textarea::placeholder,
      [contenteditable]:empty:before,
      [contenteditable]:has(> div:only-child:empty):before {
        color: rgba(60, 60, 67, 0.3);
      }

      [contenteditable]:empty:before,
      [contenteditable]:has(> div:only-child:empty):before {
        content: attr(data-placeholder);
        pointer-events: none;
        display: block;
      }

      .pnm-textarea {
        width: 100%;
        height: 80px;
        margin: -8px 0 20px;
        padding: 12px 16px;
        box-sizing: border-box;
        resize: none;
        border: none;
        border-radius: 12px;
        background-color: white;
        box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
        font-size: 1.6rem;
        font-family: inherit;
      }

      .pnm-editable-card {
        padding: 12px 16px 16px;

        .pnm-editable-label {
          margin: 14px 0 6px;
          font-size: 1.3rem;
          color: #6b6b70;
          text-transform: uppercase;

          &:first-child {
            margin-top: 2px;
          }
        }

        .pnm-editable {
          min-height: 60px;
          padding: 10px 12px;
          box-sizing: border-box;
          background-color: #f2f2f7;
          border-radius: 8px;
          font-size: 1.5rem;
          color: #1c1c1e;
        }
      }

      .pnm-booking {
        display: flex;
        flex-direction: column;
        align-items: stretch;
        gap: 16px;

        .ios-time-grid {
          width: 100%;
          align-items: stretch;
          box-sizing: border-box;

          .ios-time-grid-column {
            align-items: stretch;
          }

          .ios-time-grid-tiles {
            grid-template-columns: repeat(5, 1fr);
            grid-auto-rows: 40px;
            gap: 8px;
          }

          .ios-time-grid-tile {
            width: 100%;
            height: 100%;
            font-size: 1.5rem;
          }
        }
      }

      .pnm-summary {
        width: 100%;
        margin: 0;
        padding: 12px 16px;
        box-sizing: border-box;
        text-align: center;
        font-size: 1.6rem;
        font-weight: 600;
        color: #1c1c1e;
        background: white;
        border-radius: 12px;
        box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);

        &--empty {
          font-weight: 400;
          color: rgba(60, 60, 67, 0.55);
          background: transparent;
          box-shadow: none;
        }
      }

      .pnm-save-error {
        margin: 0 20px 12px;
        font-size: 1.4rem;
        color: @pnm-error-text;
        text-align: center;
      }

      .pnm-actions {
        position: sticky;
        bottom: 0;
        display: flex;
        gap: 10px;
        padding: 12px 20px calc(12px + env(safe-area-inset-bottom));
        background-color: rgba(242, 242, 247, 0.5);
        backdrop-filter: blur(10px);
        border-top: 0.5px solid rgba(60, 60, 67, 0.18);
        box-shadow: 0 -4px 12px rgba(0, 0, 0, 0.08);

        button {
          flex: 1;
          height: 44px;
          border: none;
          border-radius: 8px;
          font-size: 1.6rem;
          font-weight: 600;
          cursor: pointer;
          -webkit-tap-highlight-color: transparent;
          &:disabled {
            opacity: 0.6;
            cursor: not-allowed;
          }
        }

        .pnm-cancel-btn {
          background-color: #e5e5ea;
          color: #1c1c1e;
        }

        .pnm-save-btn {
          background-color: @dark-green;
          color: white;
        }
      }
    }
  }
</style>
